import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/App/App';
import {setLoggedIn} from "./redux/reducers/login-reducer";
import {store} from "./redux/store"
import {isTokenExpired} from "./utils/auth";


const refreshToken = localStorage.getItem('refresh_token')
if (refreshToken) {
    if (!isTokenExpired(refreshToken)){
        store.dispatch(setLoggedIn(true))
    }
} else {
    store.dispatch(setLoggedIn(false))
}


ReactDOM.render(
    <App/>,
  document.getElementById('root')
)
